import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { SideNavigationService } from '../../services/navigation-service/side-navigation.service';
import { CurrentNavigationItemService } from '../../services/navigation-service/current-navigation-item.service';
import { ResetStartPagePopupComponent } from '../reset-startpage-popup/reset-start-page-popup.component';
import { PlatformService } from '../../services/platform-service/platform.service';
import { MainContainerComponent } from './main-container/main-container.component';
import { NavigationHistoryService } from '../../services/navigation-service/navigation-history.service';
import { BrowserBackButtonClickedListener } from '../../event-listener/browser-back-button-clicked.listener';
import { FeedbackPopupComponent } from '../feedback-popup/feedback-popup.component';
import { FeedbackConfirmationPopupComponent } from './feedback-confirmation-popup/feedback-confirmation-popup.component';
import { MaintenanceBannerComponent } from '../maintenance-banner/maintenance-banner.component';

@Component({
  selector: 'app-navigation',
  imports: [
    HeaderComponent,
    ResetStartPagePopupComponent,
    MainContainerComponent,
    FeedbackPopupComponent,
    FeedbackConfirmationPopupComponent,
    MaintenanceBannerComponent,
  ],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  constructor(
    protected sideNavigationService: SideNavigationService,
    protected currentNavigationItemService: CurrentNavigationItemService,
    protected platformService: PlatformService,
    protected navigationHistoryService: NavigationHistoryService,
    protected browserBackButtonClickedListener: BrowserBackButtonClickedListener,
  ) {
    this.navigationHistoryService.init();
  }
}
